import Repository from './Repository';
import { CreateRecipeCategory } from '@/models/Recipes/CreateRecipeCategory';
import { DeleteRecipeCategory } from '@/models/Recipes/DeleteRecipeCategory';
import ListRequest from '@/models/ListRequest';
import { CreateRecipe } from '@/models/Recipes/CreateRecipe';
import { UpdateRecipe } from '@/models/Recipes/UpdateRecipe';
import { SearchSubRecipes } from '@/models/Recipes/SearchSubRecipes';
import { SearchRecipes } from '@/models/Recipes/SearchRecipes';
import { UpdateRecipeCategory } from '@/models/Recipes/UpdateRecipeCategory';
import { RecipeCalculate } from '@/models/Recipes/RecipeCalculate';
import { Recipe } from '@/models/Recipes/Recipe';
import { RecipeCompositionMeasurement } from '@/models/Recipes/RecipeCompositionMeasurement';
import { ListResult } from './ResultTypes/ListResult';
import { MethodResult } from './ResultTypes/MethodResult';
import { AxiosResponse } from 'axios';


const resource = '/recipes';

export default {
    createRecipeCategory(createRecipeCategory: CreateRecipeCategory) {
        return Repository.post(`${resource}/CreateRecipeCategory`, createRecipeCategory, { withCredentials: true });
    },
    listRecipeCategories() {
        return Repository.get(`${resource}/ListRecipeCategories`, { withCredentials: true });
    },
    deleteRecipeCategory(deleteRecipeCategory: DeleteRecipeCategory) {
        return Repository.post(`${resource}/DeleteRecipeCategory`, deleteRecipeCategory, { withCredentials: true });
    },
    listRecipes(listRequest: ListRequest) {
        return Repository.post(`${resource}/ListRecipes`, listRequest, { withCredentials: true });
    },
    getRecipeDetails(id: number) {
      return Repository.post<{recipeId: number}, AxiosResponse<MethodResult<Recipe>>>(
        `${resource}/GetRecipeDetails`,
        { recipeId: id },
        { withCredentials: true }
      );
    },
    createRecipe(createRecipe: CreateRecipe) {
        return Repository.post(`${resource}/CreateRecipe`, createRecipe, { withCredentials: true });
    },
    deleteRecipe(id: number) {
        return Repository.post(`${resource}/DeleteRecipe`, { recipeId: id }, { withCredentials: true });
    },
    udateRecipe(updateRecipe: UpdateRecipe) {
        return Repository.post(`${resource}/UpdateRecipe`, updateRecipe, { withCredentials: true });
    },
    searchSubRecipes(searchSubRecipes: SearchSubRecipes) {
        return Repository.post(`${resource}/SearchSubRecipes`, searchSubRecipes, { withCredentials: true });
    },
    searchRecipes(searchRecipes: SearchRecipes) {
        return Repository.post(`${resource}/SearchRecipes`, searchRecipes, { withCredentials: true });
    },
    // deleteRecipes(recipeIds: number[]) {
    //     return Repository.post(`${resource}/DeleteRecipes`, { recipeIds }, { withCredentials: true });
    // },
    renameCategory(updateCategory: any) {
        return Repository.post(`${resource}/RenameRecipeCategory`, updateCategory, { withCredentials: true });
    },
    moveRecipesToCategory(moveRecipesToCategory: any) {
        return Repository.post(`${resource}/MoveRecipesToRecipeCategory`, moveRecipesToCategory, { withCredentials: true });
    },
    filterRecipesNames(recipesSearchTerm: any) {
        return Repository.post(`${resource}/filterRecipesNames`, { recipeSearchTerm: recipesSearchTerm }, { withCredentials: true });
    },
    calculate(recCalc: RecipeCalculate) {
        return Repository.post(`${resource}/CalculateRecipeNutritions`, recCalc, { withCredentials: true });
    },
    copyRecipe(data: any) {
        return Repository.post(`${resource}/CopyRecipe`, data, { withCredentials: true });
    },
    saveRecipeLabel(data: any) {
        return Repository.post(`${resource}/SaveRecipeLabel`, data, { withCredentials: true });
    },
    getRecipeLabel(data: any) {
        return Repository.post(`${resource}/GetRecipeLabel`, data, { withCredentials: true });
    },
    deleteRecipes(data: any) {
        return Repository.post(`${resource}/DeleteRecipes`, data, { withCredentials: true });
    },
    listRestaurantRecipesAsLookups(restaurantId: number) {
        return Repository.get(`${resource}/ListRestaurantRecipesAsLookups?restaurantId=${restaurantId}`, { withCredentials: true });
    },
    listCookingMethods() {
        return Repository.get(`${resource}/ListCookingMethods`, { withCredentials: true });
    },
    listFoodGroupClasses() {
        return Repository.get(`${resource}/ListFoodGroupClasses`, { withCredentials: true });
    },
    listFoodGroupSubClasses(data: any) {
        return Repository.post(`${resource}/ListFoodGroupSubClasses`, data, { withCredentials: true });
    },
    updateRecipeFoodClassifications(data: any) {
        return Repository.post(`${resource}/UpdateRecipeFoodClassifications`, data, { withCredentials: true });
    },
    updateRecipeServingSize(data: any) {
        return Repository.post(`${resource}/UpdateRecipeServingSize`, data, { withCredentials: true });
    },
    updateCaloriesCalculationMethod(data: any) {
        return Repository.post(`${resource}/UpdateCalculationMethods`, data, { withCredentials: true });
    },
    hasRecipeWithIngredientsFromSpecificDatabase(nutrientSource: any) {
        return Repository.post(`${resource}/HasRecipeWithIngredientsFromSpecificDatabase`, { nutrientSource: nutrientSource }, { withCredentials: true })
    },
    listRecipesThatUseIngredient(ingredientId: number) {
        return Repository.get(`${resource}/ListRecipesThatUseIngredient?IngredientId=${ingredientId}`, { withCredentials: true });
    },
    getRecipeCompositionMeasurements() {
        return Repository.get<ListResult<RecipeCompositionMeasurement>>(
          `${resource}/GetRecipeCompositionMeasurements`,
          { withCredentials: true }
        );
    }
};
